import './App.css';
import { useEffect, useState } from 'react';

function App() {
  const [displayed, setDisplayed] = useState(false);
  const [started, setStarted] = useState(false);
  const [results, setResults] = useState([]);
  const [selected, setSelected] = useState(null);
  const [num1, setNum1] = useState(0);
  const [num2, setNum2] = useState(0);

  const generateRandom = () => {
    const random = Math.floor(Math.random() * 10);
    if (random <= 1) {
      if (Math.random() < 0.5) return generateRandom();
    }
    return random;
  }

  const generateTask = () => {
    const val1 = generateRandom();
    const val2 = generateRandom();
    setNum1(val1);
    setNum2(val2);
    setResults([val1 * val2]);
  };

  const startGame = () => {
    setStarted(true);
    generateTask();
  };

  const handleNew = () => {
    setDisplayed(false);
    generateTask();
    setSelected(null);
  };

  const generateRandomNumber = (val) => {
    const value = Math.floor(Math.random() * 3);
    const operator = Math.random() > 0.5 ? 'add' : 'subtract';

    if (val === 0) {
      return val + value;
    } else if (val === 1) {
      return operator === 'add' ? val + value : val - 1;
    } else if (val === 9) {
      return operator === 'add' ? val + 1 : val - value;
    } else if (val === 10) {
      return val - value;
    } else {
      return operator === 'add' ? val + value : val - value;
    }
  }

  const generateResult = (val1, val2) => {
    const random1 = generateRandomNumber(val1);
    const random2 = generateRandomNumber(val2);
    const product = random1 * random2;

    if (!results.includes(product)) {
      return product
    } else {
      return generateResult(val1, val2)
    }
  };

  const handleResult = (result) => {
    setSelected(result);
    setDisplayed(true);

    setTimeout(() => {
      handleNew();
    }, 1250);
  }

  const toggleDisplayResult = () => {
    setDisplayed(displayed => !displayed);
  }

  useEffect(() => {
    if (started) {
      if (results.length < 4) {
        const randomResult = generateResult(num1, num2)
        setResults(prevResults => randomize([...prevResults, randomResult]));
      }
    }
  }, [started, selected, num1, num2, results]);

  const randomize = (arr) => {
    let currentIndex = arr.length, randomIndex;

    while (currentIndex !== 0) {
      randomIndex = Math.floor(Math.random() * currentIndex);
      currentIndex--;

      [arr[currentIndex], arr[randomIndex]] = [
        arr[randomIndex], arr[currentIndex]];
    }

    return arr;
  };

  const isCorrect = selected === num1 * num2;

  const applyStyle = (result) => {
    if (selected === null) return 'neutral';
    if (result === num1 * num2) return 'tacan-izbor'
    return 'netacan-izbor'
  }

  return (
    <div className='App'>
      {!started ? (

        <div className="start-game-container buttons-container">
          <button onClick={startGame} className="start-btn">Започни игру</button>
        </div>
      ) : (
        <>
          <h1 className="title">Израчунај:</h1>
          <div className="numbers-container flex flex-vertical">
            <div className="brojevi flex flex-horizontal justify-center">
              <h1 className="broj">{num1}</h1>
              <h1 className="puta">·</h1>
              <h1 className="broj">{num2}</h1>
            </div>

            {results.map((result) => (
              <button
                key={result}
                disabled={selected !== null}
                className={applyStyle(result)}
                onClick={() =>
                  handleResult(result)
                }
              >{result}</button>
            ))}

            <div className={'resenje'}>
              {displayed && (
                <div className={`${selected === null ? 'nema-odgovora' : isCorrect ? 'tacan-odgovor' : 'netacan-odgovor'} resenje-prikazano flex flex-vertical align-center`}>
                  {isCorrect ? (
                    <h2>Тачан одговор!</h2>
                  ) : (
                    <>
                      <h2>Решење:</h2>
                      <h1>{num1 * num2}</h1>
                    </>
                  )}
                </div>
              )}
            </div>
          </div>

          <div className='buttons-container flex flex-horizontal'>
            <button disabled={selected !== null} onClick={handleNew} className="novi-zadatak">Нови задатак</button>
            <button
              onClick={() => {
                selected === null && toggleDisplayResult()
              }}
              className="prikazi-resenje"
            >{displayed && selected === null ? 'Сакриј' : 'Прикажи'}<br />решење
            </button>

          </div>
        </>
      )}
    </div>
  );
}

export default App;
